import { render } from "./DiceSkin.vue?vue&type=template&id=6096d122&scoped=true&ts=true"
import script from "./DiceSkin.vue?vue&type=script&lang=ts"
export * from "./DiceSkin.vue?vue&type=script&lang=ts"

import "./DiceSkin.vue?vue&type=style&index=0&id=6096d122&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6096d122"]])

export default __exports__